import { axiosBaseQuery } from '@client';
import { createApi } from '@reduxjs/toolkit/dist/query/react';
import { ActivityTypeResponse } from '../../types';
import {
  AppointmentActivityTypeConfigurationResponse,
  AppointmentActivityTypeConfigurationResponseWithOrder
} from '../../types/AppointmentActivityTypeConfigurationResponse';

export const activityTypeConfigApi = createApi({
  baseQuery: axiosBaseQuery(),
  tagTypes: ['ActivityTypesConfig'],
  reducerPath: 'activity-types-configuration_api',
  endpoints: (build) => ({
    fetchActivityTypeConfig: build.query<
      AppointmentActivityTypeConfigurationResponseWithOrder[],
      void
    >({
      query: () => ({
        url: `/secured/appointment/activity-types`,
        method: 'GET'
      }),
      transformResponse: (
        response: AppointmentActivityTypeConfigurationResponse[]
      ) => {
        return response.map((activityType, index) => ({
          ...activityType,
          order: index
        }));
      }
    }),
    fetchAllActivityTypes: build.query<
      (ActivityTypeResponse & { order: number })[],
      void
    >({
      query: () => ({ url: `/secured/activity-types/list-all`, method: 'GET' }),
      transformResponse: (response: ActivityTypeResponse[]) => {
        return response.map((activityType, index) => ({
          ...activityType,
          order: index
        }));
      }
    })
  })
});

export const {
  useFetchActivityTypeConfigQuery,
  useFetchAllActivityTypesQuery
} = activityTypeConfigApi;
